// src/components/Gallery/SortDropdown.jsx
import React from 'react';

const SortDropdown = ({ sortOption, onChange }) => {
  return (
    <select
      value={sortOption}
      onChange={(e) => onChange(e.target.value)}
      className="bg-gray-800 text-white border border-gray-700 px-4 py-2 rounded"
    >
      <option value="rank">Sort by Rank</option>
      <option value="name">Sort by Name</option>
      <option value="date">Sort by Date</option>
    </select>
  );
};

export default SortDropdown;
